import { getEventCategoryOptions } from '../calendar/calendarCategories';
import { isAssaigDeMusics } from '../../utils/utils';

export const DEFAULT_STATS_EVENT_CATEGORIES = [
    { id: 'general', labels: { cat: 'General' } },
    { id: 'canalla', labels: { cat: 'Canalla' } },
    { id: 'musics', labels: { cat: 'Músics' } },
];

export const getHiddenRehearsalCategories = filters => {
    // The category list supersedes the old musician-only preference, including an empty list.
    const categories = Array.isArray(filters?.hiddenRehearsalCategories)
        ? filters.hiddenRehearsalCategories
        : filters?.assaigs_musics ? ['musics'] : [];
    return [...new Set(categories.filter(category => typeof category === 'string' && category))];
};

const getStatsEventCategory = event => event.event_category || (isAssaigDeMusics(event) ? 'musics' : 'general');

export const isHiddenStatsRehearsal = (event, filters) => event.tipus === 'assaig'
    && getHiddenRehearsalCategories(filters).includes(getStatsEventCategory(event));

export const getStatsRehearsalCategoryOptions = (catalog, events = [], filters) => {
    const options = getEventCategoryOptions(catalog?.length ? catalog : DEFAULT_STATS_EVENT_CATEGORIES);
    const seen = new Set(options.map(option => option.value));
    // Keep unknown assignments and saved filters accessible when the catalogue is unavailable or older.
    const categories = [
        ...events.filter(event => event.tipus === 'assaig').map(getStatsEventCategory),
        ...getHiddenRehearsalCategories(filters),
    ];
    categories.forEach(category => {
        if (!seen.has(category)) {
            seen.add(category);
            options.push({ value: category, label: category });
        }
    });
    return options;
};
